const YouTubeIframeLoader = {
  src: 'https://www.youtube.com/iframe_api',
  loading: false,
  loaded: false,
  listeners: [],

  load(callback) {
    this.listeners.push(callback);

    if (this.loaded) {
      this.done();
      return;
    }

    if (this.loading) {
      return;
    }

    this.loading = true;

    window.onYouTubeIframeAPIReady = () => {
      this.loaded = true;
      this.done();
    };

    const tag = document.createElement('script');

    tag.src = this.src;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  },

  done() {
    delete window.onYouTubeIframeAPIReady;

    while (this.listeners.length) {
      this.listeners.pop()(window.YT);
    }
  }
};

export default YouTubeIframeLoader;
